import { render, staticRenderFns } from "./null_studies.vue?vue&type=template&id=10f2a83a&scoped=true"
import script from "./null_studies.vue?vue&type=script&lang=js"
export * from "./null_studies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f2a83a",
  null
  
)

export default component.exports